import { clearAllLoaders } from '@/redux/slices/common';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const DeliveryPolicy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAllLoaders());
  }, []);
  return <div className="terms-conditions" data-sentry-component="DeliveryPolicy" data-sentry-source-file="deliveryPolicy.jsx">
            <div className="container pt-2 pb-6">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h3>Shipment and Delivery Policy:</h3>
                        <p>
                            The logistics of delivery shall be handled by us. At the time of placing an order, an
                            estimated time of delivery depending on your location would also be shared. In general, our
                            estimated delivery time is about 45 minutes to one hour. Please note that we work our best
                            to ensure that you receive your order as fast as we can but sometimes due to external
                            factors like traffic, accidents, natural calamities etc., your order might take a while
                            longer.
                        </p>
                        <p>
                            Chicking reserves the right to change its shipment and delivery policies and terms at any
                            time.
                        </p>
                        <p>
                            For any queries customer can contact via email at{' '}
                            <a href="mailto:contactus@chickinguae.com">contactus@chickinguae.com</a> or by phone at 600
                            59 59 58.
                        </p>
                    </div>
                </div>
            </div>
        </div>;
};
export default DeliveryPolicy;